module.exports = __webpack_public_path__ + "static/media/globe-world-global-svgrepo-com.f9b0c90c.svg";